export default "__VITE_ASSET__25ba71b8__"